<template>
  <div id="customerChangePasswordComponent" class="auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5">
    <div class="auth-inner-div w-100 text-center">
      <h3 class="auth-header">{{ $t('password_change') }}</h3>
    </div>
    <PasswordRequirementsCardComponent/>
    <div class="auth-inner-form-div">
      <div class="auth-input">
        <InputComponent v-for="input in customerForm.inputs"
                        class="w-100 mx-auto"
                        :name-input="input.name"
                        :data-type="input.dataType"
                        :placeholder="$t(input.placeholder)"
                        v-model:data="input.value"
                        :msg="input.validation"></InputComponent>
      </div>
    </div>
    <div class="auth-inner-div w-100 pt-3" v-if="backendValidationErrors.length">
      <!-- BACKEND VALiDATION ERRORS-->
      <template v-for="error in backendValidationErrors">
        <div class="font-small order-4 error-color">
          {{ $t(error) }}
        </div>
      </template>
    </div>
    <div class="auth-inner-div w-100 pt-4 pb-5">
      <button class="auth-customer-login-button w-100"
              @click.prevent="changePassword()"
              :disabled="loading"
              :class="{'less-padding-06': loading}">
        <span class="text-center">{{ $t('submit') }}</span>
        <span v-if="loading" class="customer-loader"></span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import './customerChangePassword.scss';

import axios from "axios";
// @ts-ignore
import InputComponent from "../input/InputComponent";
//@ts-ignore
import PasswordRequirementsCardComponent from "../../components/passwordRequirementsCard/PasswordRequirementsCardComponent.vue";
import type {IForm} from "@/interfaces/IForm.interface";
import type {IInput} from "@/interfaces/IInput.interface";
import FormValidationService from "../../services/formValidationService";
import {defineComponent} from "vue";
import apiService from "../../services/apiService";
import {routesConst} from "../../routes.js"

export default defineComponent({
  name: "CustomerChangePasswordComponent",
  components: {
    InputComponent,
    PasswordRequirementsCardComponent
  },
  setup() {
  },
  data() {
    return {
      loading: false,
      customerForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'new_password', // NOTE prop binded with store
            name: 'new_password',
            dataType: 'password',
            placeholder: 'new_password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
                password: {},
              }
            }
          },
          <IInput>{
            key: 'repeat_password', // NOTE prop binded with store
            name: 'repeat_password',
            dataType: 'password',
            placeholder: 'repeat_password',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {},
                password_match: {},
              }
            }
          }
        ]
      },
      backendValidationErrors: <string[]>[],
    }
  },
  mounted () {},
  methods: {
    changePassword() {
      this.loading = true;

      let data = {
        'hash': this.$route.params.hash
      };

      const isValid = FormValidationService.validate(this.customerForm.inputs);

      if (!isValid) {
        this.loading = false;
        return;
      }

      for (const prop in this.customerForm.inputs) {
        if (!this.customerForm.inputs.hasOwnProperty(prop)) {
          continue;
        }
        const input = this.customerForm.inputs[prop];

        data[input.key] = input.value;
      }

      axios.post(apiService.customerChangePassword(), data)
          .then(response => {
            this.$router.push(routesConst.LOGIN);
          })
          .catch(error => {
            this.handleAxiosErrors(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    handleAxiosErrors(error): void {
      this.backendValidationErrors = [];

      const response = error.response;

      if (response.status === 422) {
        const data = response.data.errors;

        for (const prop in data) {
          if (!data.hasOwnProperty(prop)) {
            continue;
          }
          for (const error of data[prop]) {
            this.backendValidationErrors.push(prop + '.' + error);
          }
        }

        return;
      }

      this.backendValidationErrors.push('key_loading_error');
      console.error(error);
    }
  }
});
</script>